var _rect, _path, _path2, _rect2, _rect3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonUpsellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#059669"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 35.547c5.549 0 10.047-4.498 10.047-10.047S31.049 15.453 25.5 15.453 15.453 19.951 15.453 25.5 19.951 35.547 25.5 35.547z",
    stroke: "#fff",
    strokeWidth: 2.009,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 19.472V25.5l4.019 2.01",
    stroke: "#fff",
    strokeWidth: 2.009,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.56,
    y: 28.56,
    width: 26.88,
    height: 26.88,
    rx: 13.44,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.56,
    y: 28.56,
    width: 26.88,
    height: 26.88,
    rx: 13.44,
    stroke: "#E95832",
    strokeWidth: 1.12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.333 37l-7.334 7.333L37.666 41",
    stroke: "#E95832",
    strokeWidth: 2.009,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/common_upsell_icon.2a174d59.svg";
export { SvgCommonUpsellIcon as ReactComponent };